import { render, staticRenderFns } from "./ReportCellsTable.vue?vue&type=template&id=297c88ba&scoped=true"
import script from "./ReportCellsTable.vue?vue&type=script&lang=js"
export * from "./ReportCellsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c88ba",
  null
  
)

export default component.exports